import React from 'react';
import * as utils from "../../../utils/utils";
import {Button} from "react-materialize";
import AdditionalChargeForm from "../../forms/AdditionalChargeForm";
import {connect} from "react-redux";
import Loader from "../../common/Loader";
import * as creationActions from "../../../actions/creation";
import * as invoiceActions from "../../../actions/invoice";
import Dialog from "react-toolbox/lib/dialog/Dialog";

class AdditionalCharges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogActive: false,
            chargeID: null
        };
    }

    deleteCharge = () => {
        if (this.state.chargeID !== null) {
            this.props.dispatch(invoiceActions.remove(this.state.chargeID));
        }
        this.setState({...this.state, dialogActive: false, chargeID: null});
    };

    formatLabel = (label) => {
        let newLabel;
        let labels = label.split('<br>');
        let leftPart = labels.slice(0,3);
        labels.splice(0,3);
        newLabel = leftPart.join('<br>') + ' ' + labels.join(' ');

        return(newLabel);
    };

    render() {
        let fog = {};

        if (this.props.loading || this.props.saving) {
            return (<Loader />)
        }

        if (utils.notNullNorUndefined(this.props.fogs.getById(this.props.fog.id))) {
            fog = this.props.fogs.getById(this.props.fog.id);
        } else {
            return (<Loader />)
        }

        return (
            <div>
                {utils.notNullNorUndefined(fog.original.invoices) &&
                fog.original.invoices.map((item, index) => {
                    if (item.documentType === this.props.type) {
                        return (
                            <div className="row" key={index}>
                                <div className="additional-charge col s12 no-padding" style={{marginLeft: "31px"}}>
                                    <div className="row">
                                        <div className="label col s9 no-padding" dangerouslySetInnerHTML={{__html: this.formatLabel(utils.nl2br(item.label))}} />
                                        <div className="amount col s3 no-padding right-align">
                                            {utils.money(item.amount, utils.notNullNorUndefined(this.props.fog.currency) ? this.props.fog.currency.isoCode : '')}
                                            <i>
                                                <Button type="button" floating onClick={() => this.props.openDrawer(AdditionalChargeForm, {item: item, fog: this.props.fog, type: this.props.type}, creationActions.destroyingnewlyCreatedInvoice())} icon="edit" className="edit-button small"/>
                                            </i>
                                        </div>
                                        <i className="fog-remove-button">
                                            <Button type="button" floating onClick={() => this.setState({...this.state, dialogActive: true, chargeID: item.id})} icon="delete" className="small"/>
                                        </i>
                                        <hr />
                                    </div>
                                </div>
                            </div>
                        );
                    } else {
                        return '';
                    }
                })}
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, chargeID: null}) },
                        { label: "Yes", onClick: () => this.deleteCharge() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this Additional Charge ?</p>
                </Dialog>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        fogs: state.fog.fogs,
        loading: state.fog.loading || state.invoice.loading,
        saving: state.fog.saving || state.invoice.saving,
    });
})(AdditionalCharges);


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/AdditionalCharges.js